import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Remembers the last full path+search a list route (Courses/Lessons/Maps) was
// on, so in-app "back to list" controls (sidebar nav, editor back buttons,
// post-create/delete redirects) can restore the list's search/sort/page
// instead of navigating to the bare path. Browser back/forward already gets
// this for free by replaying history; this covers the controls that don't.
const STORAGE_KEY_PREFIX = 'authorai.lastListPath.';

function rememberListPath(basePath: string, fullPath: string): void {
  try {
    window.sessionStorage.setItem(`${STORAGE_KEY_PREFIX}${basePath}`, fullPath);
  } catch {
    // Ignore storage failures (private mode / quota); back controls fall back to the bare path.
  }
}

export function getRememberedListPath(basePath: string): string {
  try {
    return window.sessionStorage.getItem(`${STORAGE_KEY_PREFIX}${basePath}`) ?? basePath;
  } catch {
    return basePath;
  }
}

export function useRememberListPath(basePath: string): void {
  const location = useLocation();
  useEffect(() => {
    rememberListPath(basePath, `${location.pathname}${location.search}`);
  }, [basePath, location.pathname, location.search]);
}
